
/* Aligned size dropdown: forward choices to Shrine's original select/change pipeline. */
(function () {
  function closePicker(picker) {
    const menu = picker.querySelector('.kh-size-picker__menu');
    const trigger = picker.querySelector('.kh-size-picker__trigger');
    menu.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }
  function setup(root) {
    (root || document).querySelectorAll('[data-kh-size-picker]:not([data-kh-ready])').forEach(function (picker) {
      const native = picker.parentElement.querySelector('select.select__select');
      if (!native) return;
      const rows = Array.from(picker.querySelectorAll('.kh-size-picker__option'));
      if (!rows.length || rows.length !== native.options.length) return;
      const trigger = picker.querySelector('.kh-size-picker__trigger');
      const menu = picker.querySelector('.kh-size-picker__menu');
      const current = picker.querySelector('.kh-size-picker__current');
      // Read preferred header order from the theme editor; fall back to the variant's order.
      function parseSizes(value) {
        const parts = String(value).split('|').map(function (part) { return part.trim(); });
        if (parts.length !== 3) return null;
        const sizes = {};
        for (const part of parts) {
          const match = part.match(/^(EU|UK|US)\s+(.+)$/i);
          if (!match || sizes[match[1].toUpperCase()]) return null;
          sizes[match[1].toUpperCase()] = match[2].trim();
        }
        return Object.keys(sizes).length === 3 ? sizes : null;
      }
      const configured = (picker.dataset.khHeaders || '').split(',').map(function (s) { return s.trim().toUpperCase(); });
      const first = rows.map(function (r) { return r.dataset.value; }).find(function (v) { return parseSizes(v); });
      const fallback = first ? first.split('|').map(function (p) { return p.trim().split(/\s+/)[0].toUpperCase(); }) : ['EU', 'UK', 'US'];
      const validOrder = configured.length === 3 && new Set(configured).size === 3 && ['EU','UK','US'].every(function (r) { return configured.includes(r); });
      const order = validOrder ? configured : fallback;
      const showPrefixes = picker.dataset.khShowPrefixes === 'true';
      picker.querySelectorAll('.kh-size-picker__head > span').forEach(function (span, i) { span.textContent = order[i]; });
      rows.forEach(function (row) {
        const sizes = parseSizes(row.dataset.value);
        if (!sizes) return;
        row.querySelectorAll(':scope > span').forEach(function (span, i) { span.textContent = (showPrefixes ? order[i] + ' ' : '') + sizes[order[i]]; });
      });
      picker.dataset.khReady = 'true';
      function sync() {
        const selected = native.value;
        current.textContent = selected;
        rows.forEach(function (row) {
          const opt = Array.from(native.options).find(function (o) { return o.value === row.dataset.value; });
          row.disabled = !opt || opt.disabled || opt.classList.contains('non-existent') || opt.classList.contains('unavailable');
          row.setAttribute('aria-selected', String(row.dataset.value === selected));
        });
      }
      trigger.addEventListener('click', function () {
        const opening = menu.hidden;
        document.querySelectorAll('[data-kh-size-picker]').forEach(closePicker);
        menu.hidden = !opening;
        trigger.setAttribute('aria-expanded', String(opening));
      });
      rows.forEach(function (row) {
        row.addEventListener('click', function () {
          if (row.disabled) return;
          native.value = row.dataset.value;
          sync();
          closePicker(picker);
          native.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      native.addEventListener('change', sync);
      picker.hidden = false;
      sync();
    });
  }
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-kh-size-picker]').forEach(function (picker) {
      if (!picker.contains(event.target)) closePicker(picker);
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') document.querySelectorAll('[data-kh-size-picker]').forEach(closePicker);
  });
  document.addEventListener('DOMContentLoaded', function () { setup(document); });
  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
  const observer = new MutationObserver(function () { setup(document); });
  observer.observe(document.documentElement, { childList:true, subtree:true });
})();
